var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-devx-margin-block"},[((_vm.treeLocations.length !== 0 && _vm.observations.length !== 0))?_c('div',{style:(_vm.minHeight),attrs:{"id":`${_vm.nameMap}_${_vm.initialDate}`}}):_c('div',[_vm._v("\n    "+_vm._s(_vm.$t('GISGeoJsonMap_not_observations'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }